import { PageLayout } from '~/components/PageLayout/PageLayout';
import { Table } from '~/components/Table/Table';
import { Link } from '~/components/Link/Link';
import { Fragment } from 'react/jsx-runtime';
import { District } from '~/apis/ssf';

interface Props {
  district: Pick<District, 'region' | 'rfnr' | 'website' | 'email'>;
}

export function DistrictBasicInfo({ district }: Props) {
  return (
    <Fragment>
      <PageLayout.SubHeading>Generell information</PageLayout.SubHeading>

      <Table bg="odd">
        <Table.Body>
          <Table.Row>
            <Table.Col as="th">Föreningsnummer</Table.Col>
            <Table.Col>{district.rfnr ?? '-'}</Table.Col>
          </Table.Row>

          <Table.Row>
            <Table.Col as="th">Region</Table.Col>
            <Table.Col>{district.region.name}</Table.Col>
          </Table.Row>

          <Table.Row>
            <Table.Col as="th">Hemsida</Table.Col>
            <Table.Col>
              {district.website ? (
                <Link to={district.website} target="_blank">
                  {district.website}
                </Link>
              ) : (
                '-'
              )}
            </Table.Col>
          </Table.Row>

          <Table.Row>
            <Table.Col as="th">Email</Table.Col>
            <Table.Col>
              {district.email ? <Link to={`mailto:${district.email}`}>{district.email}</Link> : '-'}
            </Table.Col>
          </Table.Row>
        </Table.Body>
      </Table>
    </Fragment>
  );
}
